"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Divider;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-left: 1px solid ", ";\n  height: 33px;\n  margin-left: 8px;\n  margin-right: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DividerDiv = _styledComponents.default.div.withConfig({
  displayName: "Divider__DividerDiv",
  componentId: "e5kt7x-0"
})(_templateObject(), _colors.BATTLESHIP);

function Divider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var className = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(DividerDiv, (0, _extends2.default)({}, props, {
    className: "display-inline-block " + className
  }));
}

module.exports = exports.default;